"use strict";
exports.__esModule = true;
exports.AppLandingHelper = void 0;
// Check type to prevent window undefined error for SSR
var host = typeof window !== 'undefined' ? window.location.hostname : '';
var subDomain = 'app.';
var protocol = 'https://';
function toggleRoute(path) {
    var link = getLink(path);
    window.location.assign(link);
}
function getLink(path) {
    var index = host.indexOf(subDomain);
    var onSubDomainNow = index >= 0;
    var toggledSubDomain = onSubDomainNow ? '' : subDomain;
    var urlWithoutSubDomain = onSubDomainNow ? host.slice(index + subDomain.length) : host;
    var pathWithDivider = path ? "/" + path : '';
    return "" + protocol + toggledSubDomain + urlWithoutSubDomain + pathWithDivider;
}
exports.AppLandingHelper = {
    toggleRoute: toggleRoute,
    getLink: getLink
};
